const SUBS_KEY = "mcs_subscribed_creators";

export const readSubscribedCreators = () => {
  try {
    return new Set(JSON.parse(localStorage.getItem(SUBS_KEY) || "[]"));
  } catch {
    return new Set();
  }
};

export const recordSubscription = (creatorId, subscribed) => {
  if (!creatorId) return;
  try {
    const set = readSubscribedCreators();
    if (subscribed) set.add(creatorId);
    else set.delete(creatorId);
    localStorage.setItem(SUBS_KEY, JSON.stringify([...set]));
  } catch {}
};

const uniqBy = (items, key) => {
  const seen = new Set();
  return items.filter((it) => {
    const k = key(it);
    if (k == null || seen.has(k)) return false;
    seen.add(k);
    return true;
  });
};

const randomShuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

// Order a list of content items for the feed:
// - signed-in: items from subscribed creators first (newest first), then a shuffled mix of the rest
// - signed-out: a fresh random mix
// Always de-duplicated by id.
export const orderFeed = (items, user) => {
  const all = uniqBy(items || [], (x) => x.id);
  if (!user) return { fromSubs: [], rest: randomShuffle(all), personalized: false };

  const subscribedIds = readSubscribedCreators();
  all.forEach((it) => {
    if (it.creator?.isSubscribed || it.isSubscribed) subscribedIds.add(it.creatorId || it.creator?.id);
  });
  const isFromSub = (it) => subscribedIds.has(it.creatorId || it.creator?.id);
  const byNewest = (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0);

  const fromSubs = all.filter(isFromSub).sort(byNewest);
  const rest = randomShuffle(all.filter((it) => !isFromSub(it)));
  return { fromSubs, rest, personalized: fromSubs.length > 0 };
};
